// =============================================
// AccountPicker — wspolny selektor konta Cloudflare (Domeny w CF, Rekordy DNS,
// kreator Przenies domeny). Opcjonalnie pokazuje liczbe zon per konto i
// blokuje konta bez Account ID (nie moga tworzyc zon).
// =============================================
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import type { CloudflareAccount } from "@/hooks/useCloudflareAccounts";

interface Props {
  accounts: CloudflareAccount[];
  value: string;
  onChange: (id: string) => void;
  /** Liczba zon per konto (cloudflare_accounts.id) — dopisywana do etykiety. */
  zoneCounts?: Record<string, number>;
  /** Konta bez account_id niewybieralne (potrzebne do addZone). */
  requireAccountId?: boolean;
  disabled?: boolean;
  className?: string;
  placeholder?: string;
}

export const AccountPicker = ({
  accounts, value, onChange, zoneCounts, requireAccountId = false, disabled, className = "w-72", placeholder = "Wybierz konto Cloudflare",
}: Props) => (
  <Select value={value} onValueChange={onChange} disabled={disabled}>
    <SelectTrigger className={className}><SelectValue placeholder={placeholder} /></SelectTrigger>
    <SelectContent>
      {accounts.map((a) => {
        const noId = requireAccountId && !a.account_id?.trim();
        const zones = zoneCounts?.[a.id];
        return (
          <SelectItem key={a.id} value={a.id} disabled={noId}>
            {a.label}
            {a.email ? ` · ${a.email}` : ""}
            {typeof zones === "number" ? ` · ${zones} ${zones === 1 ? "zona" : "zon"}` : ""}
            {noId ? " · brak Account ID" : ""}
          </SelectItem>
        );
      })}
    </SelectContent>
  </Select>
);
